import { render, staticRenderFns } from "./EditResign.vue?vue&type=template&id=1ab85883&"
import script from "./EditResign.vue?vue&type=script&lang=js&"
export * from "./EditResign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports